import PropTypes from 'prop-types';
import React from 'react';

import { propTypesSliceHomepageWeb } from '../../../../templates/HomepageWeb/components/SliceZoneHomepageWeb/SliceZoneHomepageWeb.proptypes';
import { propTypesUTMs } from '../../../constants/Proptypes';

import Button from '../../../../ui/Atoms/Button';
import { Typewriter } from './Typewriter';

import { Themes } from '../../../constants/Enums';
import { getUrlWithUTMs } from '../../../utils/getUTM';
import * as S from './HeaderHomepage.styles';

const Text = React.lazy(() => import('../../../../ui/Atoms/Text'));

export const HeaderHomepageSlice = ({ slice, utms }) => {
  if (!slice) {
    return null;
  }

  const data = slice.primary || {};
  const {
    header_homepage_slice_id: id,
    header_title: { html: title } = {},
    header_title_with_dynamic_text: { html: titleDynamicText } = {},
    header_dynamic_text: dynamicText,
    header_subtitle: subtitle,
    header_cta_label: label,
    header_cta_link: { id: documentID, url, target },
    header_cta_datatrack: datatrackAttribute,
  } = data || '';

  let wordDynamicText = [];

  if (dynamicText !== '') {
    wordDynamicText = dynamicText.split(';');
  }

  const flatMap = (array, fn) => {
    let result = [];
    for (let i = 0; i < array.length; i++) {
      const mapping = fn(array[i]);
      result = result.concat(mapping);
    }
    result.pop();
    return result;
  };

  let titleWithDynamicText = titleDynamicText.replace('<h2>', '');
  titleWithDynamicText = titleWithDynamicText.replace('</h2>', '');

  const result = flatMap(
    titleWithDynamicText.split('{{dynamic_text}}'),
    part => [
      part,
      <Typewriter
        autoloop={true}
        delaySpeed='500'
        deleteSpeed='60'
        key={0}
        typeSpeed='90'
        words={wordDynamicText}
      />,
    ]
  );

  if (!title) {
    return null;
  }

  return (
    <S.HeaderHomepage id={id}>
      <S.Wrapper>
        <S.ContentContainer>
          <React.Suspense fallback='Loading...'>
            <Text>{title}</Text>
          </React.Suspense>
          <S.TitleDynamicWrapper>
            {result}
            <noscript>{wordDynamicText[0]}</noscript>
          </S.TitleDynamicWrapper>

          <S.Subtitle>{subtitle}</S.Subtitle>
          {url && label && (
            <>
              <Button
                dataTrackAttribute={datatrackAttribute}
                isGatsbyLink={!!documentID}
                link={getUrlWithUTMs({ url, utms })}
                target={target}
                theme={Themes.WOOCLAP}
              >
                {label}
              </Button>
            </>
          )}
        </S.ContentContainer>
      </S.Wrapper>
    </S.HeaderHomepage>
  );
};

HeaderHomepageSlice.propTypes = {
  /**
   * Content of the HeaderBasic slice.
   */
  slice: PropTypes.shape(propTypesSliceHomepageWeb),
  /**
   * Optional UTMs.
   */
  utms: PropTypes.shape(propTypesUTMs),
};
